import { ActivityOption, NotificationGroupType } from "PFCore/types";
import { useState } from "react";

import { NotificationsPanelContext } from "./notifications_panel_context";

export const NotificationsPanelContextProvider = ({ children }) => {
  const [categories, setCategories] = useState<string[]>([]);
  const [role, setRole] = useState<ActivityOption | undefined>(undefined);
  const [engagement, setEngagement] = useState<ActivityOption | undefined>(undefined);
  const [showUnreadOnly, setShowUnreadOnly] = useState<boolean>(false);
  const [showImportantOnly, setShowImportantOnly] = useState<boolean>(false);
  const [groupBy, setGroupBy] = useState<NotificationGroupType>(NotificationGroupType.None);

  return (
    <NotificationsPanelContext.Provider
      value={{
        engagement,
        setEngagement,
        role,
        setRole,
        categories,
        setCategories,
        showUnreadOnly,
        setShowUnreadOnly,
        showImportantOnly,
        setShowImportantOnly,
        groupBy,
        setGroupBy
      }}
    >
      {children}
    </NotificationsPanelContext.Provider>
  );
};
